export default {
  metadata: {
    version: '1.0.0',
    id: 'search-results-1.0.0',
    name: 'JDSSearchResults'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_search_results_internal']
      }
    ]
  },
  base: {
    popup: {
      'background-color': '{global.transparent}',
      priority: 40,
      hidden: true,
      passive: true
    },
    'popup-container': {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.center}',
      width: '{size.max}',
      'background-color': '{global.transparent}',
      'border-radius': 0
    }
  },
  variant: {
    open: {
      true: {
        popup: {
          hidden: false
        }
      }
    },
    appearance: {
      box: {
        jds_search_results_internal: {
          appearance: 'box'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      appearance: {
        values: ['normal', 'box'],
        doc_description:
          "This determines the appearance of search results, it can be 'normal or 'box'."
      },
      open: {
        values: [false, true],
        doc_description: 'It can be used to open or close search result items.'
      }
    },
    data: {
      jds_search_results_internal: {
        maxWidth: {
          type: 'size',
          name: '_maxWidth'
        },
        header: {
          type: 'string',
          name: 'header',
          doc_description:
            'It is a heading that will display in the Header of the SearchResults.'
        },
        headerAction: {
          type: 'string',
          name: 'headerAction',
          doc_description:
            'If this is passed a button will appear on the right side of the Heading in the Header.'
        },
        results: {
          type: 'list',
          name: 'results',
          function: true,
          object: {
            icon: 'icon',
            label: 'string'
          }
        },
        'results.label': {
          type: 'string',
          name: 'results.label'
        },
        'results.icon': {
          type: 'icon',
          name: 'results.icon'
        },
        query: {
          type: 'string',
          name: 'query'
        }
      },
      'popup-container': {
        'padding-left': {
          type: 'size',
          name: 'offsetX'
        },
        'padding-top': {
          type: 'size',
          name: 'offsetY'
        }
      }
    },
    events: {
      jds_search_results_internal: {
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        },
        onClick: 'onClick',
        onHeaderActionClick: 'onHeaderActionClick',
        onContainerClick: '_onContainerClick'
      },
      popup: {
        onClick: '_onClose'
      }
    },
    a11y: {
      jds_search_results_internal: {
        name: 'results',
        repeating: {
          ariaLabel: 'resultAriaLabel',
          ariaDescribedby: {
            name: 'resultAriaDescribedby',
            platform: 'web,ios'
          }
        },
        properties: {
          headerActionAriaLabel: 'headerActionAriaLabel',
          headerActionAriaDescribedby: {
            name: 'headerActionAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
